import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { SAFE_PDF_DOCUMENT_OPTIONS } from './pdfSecurity';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

const MIN_SCALE = 0.5;
const MAX_SCALE = 3;
const SCALE_STEP = 0.25;

const SecurePdfViewer = ({ file }) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    setNumPages(0);
    setPageNumber(1);
    setScale(1);
  }, [file]);

  const changePage = (nextPage) => {
    if (!numPages) return;
    setPageNumber(Math.min(Math.max(nextPage, 1), numPages));
  };

  const onDocumentLoadSuccess = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
    setPageNumber((currentPage) => Math.min(currentPage, loadedPages));
  };

  return (
    <div className="archive-pdf-viewer">
      <div className="archive-pdf-toolbar" role="toolbar" aria-label="Commandes du PDF">
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          onClick={() => changePage(pageNumber - 1)}
          disabled={pageNumber <= 1}
          aria-label="Page précédente"
        >
          <i className="ri-arrow-left-s-line" aria-hidden="true"></i>
        </button>
        <label className="archive-pdf-page-control">
          <span className="sr-only">Numéro de page</span>
          <input
            type="number"
            min="1"
            max={numPages || 1}
            value={pageNumber}
            onChange={(event) => changePage(Number(event.target.value))}
          />
          <span>/ {numPages || '—'}</span>
        </label>
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          onClick={() => changePage(pageNumber + 1)}
          disabled={!numPages || pageNumber >= numPages}
          aria-label="Page suivante"
        >
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </button>
        <span className="archive-pdf-toolbar-spacer"></span>
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          onClick={() => setScale((currentScale) => Math.max(MIN_SCALE, currentScale - SCALE_STEP))}
          disabled={scale <= MIN_SCALE}
          aria-label="Réduire le zoom"
        >
          <i className="ri-zoom-out-line" aria-hidden="true"></i>
        </button>
        <span className="archive-pdf-zoom-label">{Math.round(scale * 100)}%</span>
        <button
          className="btn btn-outline-secondary btn-sm"
          type="button"
          onClick={() => setScale((currentScale) => Math.min(MAX_SCALE, currentScale + SCALE_STEP))}
          disabled={scale >= MAX_SCALE}
          aria-label="Augmenter le zoom"
        >
          <i className="ri-zoom-in-line" aria-hidden="true"></i>
        </button>
      </div>
      <div className="archive-pdf-page">
        <Document
          file={file}
          options={SAFE_PDF_DOCUMENT_OPTIONS}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<div className="archive-preview-empty">Chargement du PDF…</div>}
          error={<div className="archive-preview-empty">Impossible d’afficher ce PDF.</div>}
          externalLinkTarget="_blank"
          externalLinkRel="noopener noreferrer nofollow"
        >
          <Page pageNumber={pageNumber} scale={scale} />
        </Document>
      </div>
    </div>
  );
};

export default SecurePdfViewer;
